require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./ar-eg-institution-بنك-التنمية-للبلدان-الامريكية.json") })
        }
      }, "path---ar-eg-institution-بنك-التنمية-للبلدان-الامريكية");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---ar-eg-institution-بنك-التنمية-للبلدان-الامريكية!./.cache/json/ar-eg-institution-بنك-التنمية-للبلدان-الامريكية.json
// module id = 437
// module chunks = 231608221292675